import { Component, Vue, Prop } from 'vue-property-decorator';
import { Btn, FullScreenToggle, FormButtonDisabler, ISideDrawerContent } from '@samc/centricity-core';
import { LsGrid } from '@/Components/LSGrid';
import { IReviewOrderDetails, ITradingProductGroupSummary } from '@/Interfaces';
import { pluralize, toString, AjaxHelper, errToMessage } from '@samc/common';
import { download } from '@/utils';
import Entitlements from '@/Entitlements';

@Component({
  name: 'trading-info-side-drawer',
  components: { Btn, FullScreenToggle, LsGrid, FormButtonDisabler }
})
export default class TradingInfoSideDrawer extends Vue implements ISideDrawerContent {
  @Prop() public addCloseProp!: (callback: (preventDefault: () => void) => any) => void;
  @Prop() public cancelProp!: () => void;
  @Prop() public actionProp!: () => void;

  @Prop({ required: true }) public packageId!: string;
  @Prop({ required: true }) public tradingProductGroupId!: number | null;
  @Prop({ required: true }) public tradingProductGroupSummary!: ITradingProductGroupSummary | null;

  //public tradingGroupSummary: ITradingProductGroupSummary | null = null;

  public isDisabled: boolean = false;

  public get formatString() { return toString; }
  public get pluralize() { return pluralize; }
}